import React from 'react';
import { ArrowDown as LucideArrowDown, ArrowUp as LucideArrowUp } from 'lucide-react';

interface ArrowIconProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const ArrowUp: React.FC<ArrowIconProps> = ({ width = 16, height = 16, className, style }) => (
  <LucideArrowUp width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export const ArrowDown: React.FC<ArrowIconProps> = ({ width = 16, height = 16, className, style }) => (
  <LucideArrowDown width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);
